import { render, staticRenderFns } from "./Typography.vue?vue&type=template&id=3bd5b45f&scoped=true&"
import script from "./Typography.vue?vue&type=script&lang=js&"
export * from "./Typography.vue?vue&type=script&lang=js&"
import style0 from "./Typography.scss?vue&type=style&index=0&id=3bd5b45f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd5b45f",
  null
  
)

export default component.exports